<template>
    <v-container fluid class="" style="margin-top: 20px">
        <v-card>
            <v-card color="primary">
                <v-card-title class="title-text"> Borradores </v-card-title>
            </v-card>
            <v-card-text>
                <div style="height: 50px;"></div>
                <v-container>
                    <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                        :order="[[0, 'asc']]" @apiDT="apiDT = $event"></DataTable>
                </v-container>
            </v-card-text>
            <div style="height: 100px;"></div>
        </v-card>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import BlogService from "@/services/Blogs/Blogs.service.js";;
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable
    },
    data() {
        return {
            categoryItems: [],
            urlListado: "Blog/ObtenerPostBorradores",
            columns: [
                { name: 'baclave', data: 'baclave', title: "Clave" },
                { name: 'bafhpublicacion', data: 'bafhpublicacion', title: "Fecha de Publicación" },
                { name: 'batitulo', data: 'batitulo', title: "Titulo" },
                { name: 'baautor', data: 'baautor', title: "Autor" },
                { name: "acciones", data: "baclave", title: "", formatter: [this, "formatearRevision"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "RevisarArticulo"] },
            ],
        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    async mounted() {
        this.obtenerCategorias();

    },
    methods: {
        async obtenerCategorias() {
            let response = await BlogService.ObtenerCategorias();
            this.categoryItems = response;
        },
        async RevisarArticulo(params, item, fila) {
            let token = await MetodosGenerales.generateJsonToken(item);
            this.$emit('toggle-detail', token);
        },

        formatearRevision(datos) {
            return `<div><button type="button" class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary dt-formatterAction" data-action="0" data-params="${datos.baclave}" title="Revisar"><span class="v-btn__content"><i data-v-6d45dbae="" aria-hidden="true" class="v-icon notranslate mdi mdi-page-next theme--light"></i></span></button></div>`;
        },

    },
};
</script>

<style scoped>
.title-text {
    font-family: "Poppins", sans-serif;
    font-size: 1.3rem !important;
    font-weight: 600 !important;
    color: white;
}

.new-category-text {
    font-family: "Poppins", sans-serif;
    font-weight: 800 !important;
    font-size: 1.6rem !important;
}
</style>